(function ($) {
  Drupal.behaviors.ehThewinkHpRedesignHeroHeaderV1 = {
    attach: function (context, settings) {
      var formatter = $('.eh-thewink-hp-redesign-hero-header-v1', context);

      formatter.once('eh-thewink-hp-redesign-hero-header').each(function () {
        var thisFormatter = $(this);
        // Get href and build the link
        var $heroLink = thisFormatter.find('.hero-link');
        var link = window.location.protocol + '//' + window.location.hostname + $heroLink.text();

        if ($heroLink.length > 0) {
          thisFormatter.css({ 'cursor': 'pointer' });
          thisFormatter.once().on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            window.location = link;
          });
        }
      });
    }
  };
})(jQuery);
